const buildQuery = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

const get = async (path, params = {}) => {
  const query = buildQuery(params);
  const url = query ? `/${path}?${query}` : `/${path}`;
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Request failed: ${res.status} ${text}`);
  }
  return res.json();
};

const put = async (path, body = {}) => {
  const res = await fetch(`/${path}`, {
    method: "PUT",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Request failed: ${res.status} ${text}`);
  }
  return res.json();
};

const patch = async (path, body = {}) => {
  const res = await fetch(`/${path}`, {
    method: "PATCH",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Request failed: ${res.status} ${text}`);
  }
  return res.json();
};

const del = async (path, params = {}) => {
  const query = buildQuery(params);
  const url = query ? `/${path}?${query}` : `/${path}`;
  const res = await fetch(url, { method: "DELETE", credentials: "same-origin" });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Request failed: ${res.status} ${text}`);
  }
  return res.json();
};

export default { get, put, patch, del };
